/** French SIRET (14 digits) / SIREN (9 digits) helpers for profiles & invoicing. */

export function normalizeSiretInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, 14);
}

export function formatSiretDisplay(value: string): string {
  const digits = normalizeSiretInput(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  if (digits.length <= 14) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)} ${digits.slice(9)}`;
  }
  return digits;
}

/** SIREN = first 9 digits of a (normalized) SIRET. */
export function sirenFromSiret(siret: string): string | null {
  const digits = normalizeSiretInput(siret);
  return digits.length >= 9 ? digits.slice(0, 9) : null;
}

/**
 * Length check only (no Luhn). Empty is allowed when allowEmpty is true.
 * Callers that need a DB-safe value should persist only when length === 14.
 */
export function isValidSiret(value: string, options?: { allowEmpty?: boolean }): boolean {
  const allowEmpty = options?.allowEmpty ?? true;
  const digits = normalizeSiretInput(value);
  if (digits.length === 0) return allowEmpty;
  return digits.length === 14;
}
